export default __webpack_public_path__ + "static/media/attachment.3dfc6d6a.svg";